var t = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Small = "small", e))(t || {});
const a = [
  "date",
  "datetime-local",
  "month",
  "time",
  "week"
];
var l = /* @__PURE__ */ ((e) => (e.Floating = "floating", e.Fixed = "fixed", e))(l || {});
export {
  t as SizesEnum,
  a as TYPES_WITH_DEFAULT_PLACEHOLDER,
  l as VariantsEnum
};
